/**
 * @file: ErpIntegrationType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpIntegrationType {
  Openapi = 'openapi',
  Extension = 'extension',
  Hosted = 'hosted',
}

export const ErpIntegrationTypeValueSet = new Set([
  ErpIntegrationType.Openapi,
  ErpIntegrationType.Extension,
  ErpIntegrationType.Hosted,
]);
